import Typography from '@mui/material/Typography';


export default function ApoTextInfo() {
  
  return (
<div>
    
    <Typography variant="h6" >
  
    <Typography component="span" variant="h6" sx={{fontWeight: '700'}}>APOE variants - polymorphism analysis</Typography>
    <br /><br />
    
    Apolipoprotein E combines with fats (lipids) in the body to form molecules called lipoproteins. Lipoproteins are responsible for packaging cholesterol and 
    other fats and carrying them through the bloodstream. Maintaining normal levels of cholesterol is essential for the prevention of disorders 
    that affect the heart and blood vessels (cardiovascular diseases), including heart attack and stroke.

    <br /><br />
    Apolipoprotein E (ApoE) gene ranks foremost among influential genes in the aging process with a strong association with exceptional longevity and age-related diseases.
    <br /><br />

    Gene APOE - Key polymorphisms:
    <br /><br />

	ε2 (rs7412-T), <br />
	ε3 (wild-type), <br />
	ε4 (rs429358-C):<br /><br />


 ε4: Associated with accelerated aging, increased risk of Alzheimer’s disease, cardiovascular issues.<br />
 ε3: wild-type: Dominant genotype (60 %) is ε3/ε3  <br />
 ε2: Protective, linked to longevity and reduced neurodegeneration<br /><br />


    <Typography component="span" variant="h6" sx={{fontWeight: '700'}}>Actionability: What can you do?</Typography>
    <br /><br />

Lifestyle interventions: Reduce saturated fat intake and increase omega-3 fatty acids to mitigate ε4 risks.<br />
Monitoring: Screen for Alzheimers disease or cardiovascular risk earlier in ε4 carriers.<br />
Pharmacological interventions: Use of statins, anti-inflammatory drugs, and possibly upcoming anti-amyloid therapies.
 <br /><br /><br />


Source: 
<Typography component="span" variant="body1" sx={{fontWeight: '200'}}>
    <br /><br />
    https://pmc.ncbi.nlm.nih.gov/articles/PMC7750679/    <br />
</Typography>

    </Typography>
</div>
)}